import React from 'react';
import OrderFileUploader from './orderFileUploader';

const OrderUploadHandler = ({ data }) => {
  return (
    <>
      {OrderFileUploader(
        data?.[0]?.name,
        data?.[0]?.path,
        data?.[0]?.orderEdit,
        data?.[0]?.fileType,
        data?.[0]?.orderStage,
        data?.[0]?.isOrder,
        data?.[0]?.orderId,
        data?.[0]?.orderCreator,
        data?.[0]?.reviewVersion,
      )}
    </>
  );
};

export default OrderUploadHandler;
